let FundamentalTabEPSToggleState  = {
  Date: 1,
  Difference: 2
}
export default FundamentalTabEPSToggleState;